module.exports = __webpack_public_path__ + "img/BIT_white15.83ac709a.jpg";